import { Category } from "fileParsing/types";
import { SubCategories } from "./index";

export enum SensitivityLevel {
  Low = "Not Sensitive",
  Medium = "Partially Sensitive",
  High = "Sensitive",
}

export type SensitivityMapping = { [key: string]: SensitivityLevel };

export class Sensitivity {
  public static defaultSensitivity = SensitivityLevel.Medium;

  public static getSensitivity(subcategories: SubCategories): SensitivityMapping {
    const result: SensitivityMapping = {};

    Object.entries(subcategories).forEach((sc) => {
      const search = sc[0].toLowerCase();
      const match = Sensitivity.Mapping.find((e) => search.startsWith(e[0]));
      result[sc[0]] = match ? match[1] : Sensitivity.DefaultCategory[sc[1].category];
    });

    return result;
  }

  public static Facebook = {
    // ############# LOW SENSITIVITY #############
    "Registration Date": SensitivityLevel.Low,
    "Profile Updates": SensitivityLevel.Low,
    "Page Likes": SensitivityLevel.Low,

    // ############# MEDIUM SENSITIVITY #############
    "Profile Information": SensitivityLevel.Medium,
    Location: SensitivityLevel.Medium,
    Album: SensitivityLevel.Medium,
    "Posts from Apps and Websites": SensitivityLevel.Medium,
    "Your Posts in Groups": SensitivityLevel.Medium,
    "Your Posts": SensitivityLevel.Medium,
    "Other People Posts": SensitivityLevel.Medium,
    Videos: SensitivityLevel.Medium,
    Followers: SensitivityLevel.Medium,
    "Installed App": SensitivityLevel.Medium,
    "Group Interactions": SensitivityLevel.Medium,
    Friend: SensitivityLevel.Medium,
    "Posts and Comments": SensitivityLevel.Medium,
    "Post & Comment Likes": SensitivityLevel.Medium,
    "Event Invitations": SensitivityLevel.Medium,
    "Event Joined": SensitivityLevel.Medium,
    "Event Declined": SensitivityLevel.Medium,
    "Event Interested": SensitivityLevel.Medium,
    "Page Unfollowed": SensitivityLevel.Medium,
    "Groups You Joined": SensitivityLevel.Medium,
    Collections: SensitivityLevel.Medium,
    "Groups Where you are Admin": SensitivityLevel.Medium,
    Groups: SensitivityLevel.Medium,

    // ############# HIGH SENSITIVITY #############
    "Account Security": SensitivityLevel.High,
    "Security: Admin": SensitivityLevel.High,
    "Security: Authorized Logins": SensitivityLevel.High,
    "Security: Login and Logout": SensitivityLevel.High,
    "Security: Login Protection": SensitivityLevel.High,
    "Security: Active Logins": SensitivityLevel.High,
    "Viewed Personen": SensitivityLevel.High,
    "Visited Gruppen": SensitivityLevel.High,
    "Visited Profilaufrufe": SensitivityLevel.High,
    "Visited Veranstaltungen": SensitivityLevel.High,
    "Search History": SensitivityLevel.High,
    "Address Book": SensitivityLevel.High,
    "Viewed Preferences": SensitivityLevel.High,
    "Ad Interest": SensitivityLevel.High,
    Advertisers: SensitivityLevel.High,
    "Viewed Saved Post Reminders": SensitivityLevel.High,
    "Viewed falanci": SensitivityLevel.High,
    "Viewed Werbeanzeigen": SensitivityLevel.High,
    "Interaction with Ads": SensitivityLevel.High,
    "People Interaction": SensitivityLevel.High,
    Pokes: SensitivityLevel.High,
    "Poll Vote": SensitivityLevel.High,
    "Received Friend Request": SensitivityLevel.High,
    "Deleted Friend ": SensitivityLevel.High,
    "Poke Ranking": SensitivityLevel.High,
    "Sent Friend Request": SensitivityLevel.High,
    "Rejected Friend Requests": SensitivityLevel.High,
    "Chat with": SensitivityLevel.High,
    Search: SensitivityLevel.High,
    Notifications: SensitivityLevel.High,
  };

  public static Google = {
    // ############# LOW SENSITIVITY #############
    "Youtube Comments": SensitivityLevel.Low,
    "Youtube Live Comments": SensitivityLevel.Low,
    "Play Store Reviews": SensitivityLevel.Low,
    "Maps Reviews": SensitivityLevel.Low,
    "Blogger Album": SensitivityLevel.Low,
    "Blogger Image": SensitivityLevel.Low,
    "Maps Added Dishes, Products, Activites": SensitivityLevel.Low,
    "Photo Contribution": SensitivityLevel.Low,

    // ############# MEDIUM SENSITIVITY #############
    "Play Store Library": SensitivityLevel.Medium,
    "Youtube Playlist": SensitivityLevel.Medium,

    // ############# HIGH SENSITIVITY #############
    "Play Store Devices": SensitivityLevel.High,
    "Browser Autofill": SensitivityLevel.High,
    Security: SensitivityLevel.High,
    "Activity in Gmail": SensitivityLevel.High,
    "Activity in Google Assistant": SensitivityLevel.High,
    "Activity in Datenexport": SensitivityLevel.High,
    "Activity in Voice und Audio": SensitivityLevel.High,
    Contacts: SensitivityLevel.High,
    "Keep Note": SensitivityLevel.High,
    "Maps Saved Places": SensitivityLevel.High,
    Reminders: SensitivityLevel.High,
    Messages: SensitivityLevel.High,
    "Browser History": SensitivityLevel.High,
    "Location History High": SensitivityLevel.High,
    "Location History Average": SensitivityLevel.High,
    "Location History Low": SensitivityLevel.High,
    "Location History Very Low": SensitivityLevel.High,
    "Activity in Shopping": SensitivityLevel.High,
    "Activity in Google Play Spiele": SensitivityLevel.High,
    "Activity in Hilfe": SensitivityLevel.High,
    "Activity in Videosuche": SensitivityLevel.High,
    "Activity in Google News": SensitivityLevel.High,
    "Activity in Discover": SensitivityLevel.High,
    "Activity in Bildersuche": SensitivityLevel.High,
    "Activity in Google Analytics": SensitivityLevel.High,
    "Activity in Chrome": SensitivityLevel.High,
    "Activity in Google Play Store": SensitivityLevel.High,
    "Activity in Maps": SensitivityLevel.High,
    "Activity in Google Suche": SensitivityLevel.High,
    "Activity in Anzeigen": SensitivityLevel.High,
    "Activity in YouTube": SensitivityLevel.High,
    "Activity in Android": SensitivityLevel.High,
    "Youtube Search History": SensitivityLevel.High,
    "Youtube Watch History": SensitivityLevel.High,
    "Browser Search Engine": SensitivityLevel.High,
    "Play Store Purchase History": SensitivityLevel.High,
    "Browser Bookmarks": SensitivityLevel.High,
    "Play Store Order History": SensitivityLevel.High,
    "Photo Album": SensitivityLevel.High,
    Photo: SensitivityLevel.High,
    "Play Store Installs": SensitivityLevel.High,
    Printer: SensitivityLevel.High,
    "Movie Watchlist": SensitivityLevel.High,
  };

  public static Instagram = {
    // ############# LOW SENSITIVITY #############
    Profile: SensitivityLevel.Low,
    "Shopping Email": SensitivityLevel.Low,
    "Profile Picture": SensitivityLevel.Low,
    Products: SensitivityLevel.Low,

    // ############# MEDIUM SENSITIVITY #############
    Location: SensitivityLevel.Medium,
    "Media Comments": SensitivityLevel.Medium,
    "Live Comments": SensitivityLevel.Medium,
    Countdowns: SensitivityLevel.Medium,
    "Emoji Sliders": SensitivityLevel.Medium,
    Polls: SensitivityLevel.Medium,
    Questions: SensitivityLevel.Medium,
    Quizzes: SensitivityLevel.Medium,
    Followers: SensitivityLevel.Medium,
    Following: SensitivityLevel.Medium,
    "Following Hashtags": SensitivityLevel.Medium,
    "Comment Likes": SensitivityLevel.Medium,
    "Media Like": SensitivityLevel.Medium,
    Photos: SensitivityLevel.Medium,
    Stories: SensitivityLevel.Medium,
    Videos: SensitivityLevel.Medium,
    Collection: SensitivityLevel.Medium,

    // ############# HIGH SENSITIVITY #############
    Settings: SensitivityLevel.High,
    "Settings Blocked Commenters": SensitivityLevel.High,
    "Settings Filtered Keywords": SensitivityLevel.High,
    Cameras: SensitivityLevel.High,
    Devices: SensitivityLevel.High,
    "Login History": SensitivityLevel.High,
    "Ads clicked": SensitivityLevel.High,
    "Ads seen": SensitivityLevel.High,
    "Viewed Accounts": SensitivityLevel.High,
    "Posts seen": SensitivityLevel.High,
    "Videos Watched": SensitivityLevel.High,
    "Blocked Users": SensitivityLevel.High,
    Messages: SensitivityLevel.High,
    "Imported Contacts": SensitivityLevel.High,
    Chats: SensitivityLevel.High,
    "Follow Requests Sent": SensitivityLevel.High,
    "Saved Media": SensitivityLevel.High,
    "Direct Media": SensitivityLevel.High,
    "Chat with ...": SensitivityLevel.High,
    "Close Friends": SensitivityLevel.High,
  };

  public static Twitter = {
    // ############# LOW SENSITIVITY #############
    Profile: SensitivityLevel.Low,
    "Screen Name Change": SensitivityLevel.Low,
    "Verified Status": SensitivityLevel.Low,
    Like: SensitivityLevel.Low,
    Follower: SensitivityLevel.Low,
    Following: SensitivityLevel.Low,

    // ############# MEDIUM SENSITIVITY #############
    Account: SensitivityLevel.Medium,
    "Account Timezone": SensitivityLevel.Medium,
    "Age Info": SensitivityLevel.Medium,
    "Connected Application: Lists": SensitivityLevel.Medium,

    // ############# HIGH SENSITIVITY #############
    "Account Creation Ip": SensitivityLevel.High,
    "Email Adress Change": SensitivityLevel.High,
    "IP Audit": SensitivityLevel.High,
    "Direct Message with": SensitivityLevel.High,
    Impression: SensitivityLevel.High,
    "Ad Engagement": SensitivityLevel.High,
    "Ad Mobile Conversion Unattributed on": SensitivityLevel.High,
    "Ad Online Conversion Unattributed": SensitivityLevel.High,
    "Device Tokens": SensitivityLevel.High,
    "Personalization + Interests": SensitivityLevel.High,
    "Personalization + Shows": SensitivityLevel.High,
    "Saved Search": SensitivityLevel.High,
    "Imported Contacts": SensitivityLevel.High,
    "Blocked Accounts": SensitivityLevel.High,
    "Muted Accounts": SensitivityLevel.High,
  };

  public static DefaultCategory = {
    [Category.Account]: SensitivityLevel.High,
    [Category.Activity]: SensitivityLevel.High,
    [Category.Contacts]: SensitivityLevel.High,
    [Category.Likes]: SensitivityLevel.Low,
    [Category.Location]: SensitivityLevel.High,
    [Category.Media]: SensitivityLevel.High,
    [Category.Messages]: SensitivityLevel.High,
    [Category.Other]: SensitivityLevel.Low,
    [Category.PostsAndComments]: SensitivityLevel.Medium,
    [Category.Security]: SensitivityLevel.High,
  };

  private static Mapping = [
    ...Object.entries(Sensitivity.Facebook),
    ...Object.entries(Sensitivity.Google),
    ...Object.entries(Sensitivity.Instagram),
    ...Object.entries(Sensitivity.Twitter),
  ]
    .map((s) => [s[0].toLowerCase(), s[1]] as [string, SensitivityLevel])
    .sort((l, r) => r[0].length - l[0].length);
}
